import {FormControlLabel, Switch, Typography} from '@mui/material';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';

import {setAccessPermissions} from '@explorer/actions/search-filters';

const AccessFilterToggle = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const accessPermissions = useSelector(
    state => state.searchFilters.accessPermissions
  );

  const handleToggle = () => {
    dispatch(setAccessPermissions(!accessPermissions));
  };
  return (
    <FormControlLabel
      control={
        <Switch
          size="small"
          color="primary"
          checked={!accessPermissions}
          onChange={handleToggle}
        />
      }
      label={
        <Typography variant="body2">
          {t('resultsList.toggleShowFullCatalog')}
        </Typography>
      }
      labelPlacement="start"
      sx={{
        marginLeft: 0,
        marginRight: 1,
      }}
    />
  );
};

export default AccessFilterToggle;
